// extracted by mini-css-extract-plugin
module.exports = {"sideLeft":"B_bV","sideRight":"B_bW","main":"B_bX"};